import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import client from '@/api/client'

window.Pusher = Pusher

let echoInstance = null
let initFailed = false

// Nunca lanza: si Reverb no está configurado o falla la construcción,
// devuelve null y la app degrada a "sin tiempo real" en silencio.
export function getEcho() {
  if (echoInstance) return echoInstance
  if (initFailed) return null

  if (!import.meta.env.VITE_REVERB_APP_KEY) {
    initFailed = true
    console.warn('[echo] VITE_REVERB_APP_KEY no configurada — tiempo real deshabilitado')
    return null
  }

  try {
    echoInstance = createEcho()
  } catch (err) {
    initFailed = true
    echoInstance = null
    console.warn('[echo] No se pudo inicializar el WebSocket — tiempo real deshabilitado', err)
    return null
  }

  return echoInstance
}

function createEcho() {
  const instance = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: Number(import.meta.env.VITE_REVERB_PORT || 8080),
    wssPort: Number(import.meta.env.VITE_REVERB_PORT || 8080),
    forceTLS: import.meta.env.VITE_REVERB_SCHEME === 'https',
    enabledTransports: ['ws', 'wss'],
    authorizer: (channel) => ({
      authorize: async (socketId, callback) => {
        try {
          const { data } = await client.post('/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
          })
          callback(null, data)
        } catch (err) {
          callback(err, null)
        }
      },
    }),
  })

  const connector = instance.connector.pusher
  connector.connection.bind('connected', () => {
    const id = connector.connection.socket_id
    client.defaults.headers.common['X-Socket-ID'] = id
  })
  connector.connection.bind('disconnected', () => {
    delete client.defaults.headers.common['X-Socket-ID']
  })

  return instance
}

export function disconnectEcho() {
  if (echoInstance) {
    echoInstance.disconnect()
    echoInstance = null
    delete client.defaults.headers.common['X-Socket-ID']
  }
}
